import { Layout, Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import HeaderContent from './HeaderContent';

const { Header: AntHeader } = Layout;

export default function Header() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const siderWidth = drawerOpen ? DRAWER_WIDTH : MINI_DRAWER_WIDTH;

  return (
    <AntHeader
      className="fixed top-0 z-1000 flex items-center border-b border-slate-200 p-3! gap-3"
      style={{ width: `calc(100% - ${siderWidth}px)`, background: '#f8fafc' }}
    >
      <Button
        type="text"
        icon={drawerOpen ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        className="text-base"
      />
      <HeaderContent />
    </AntHeader>
  );
}
